import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
// import { StaticQuery, graphql } from 'gatsby';

// Placeholder metadata (replace with actual values or fetch from env vars)
const siteMetadata = {
  title: 'Awaken Solutions',
  description: 'AI Integration & Business Transformation Consultancy. Helping organizations adopt AI strategically, integrate systems intelligently, and reduce operational friction.',
  author: 'Awaken Solutions'
};

function SEO(props) {
  const { description, lang, meta, keywords = [], title } = props;

  const metaDescription = description || siteMetadata.description;
  const pageTitle = title || siteMetadata.title; // Use passed title or default site title

  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={pageTitle} // Use the determined page title
      titleTemplate={`%s • ${siteMetadata.title}`} // Keep site title in template
      meta={[
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: pageTitle // Use page title for OG title
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          name: `twitter:card`,
          content: `summary`
        },
        {
          name: `twitter:creator`,
          content: siteMetadata.author
        },
        {
          name: `twitter:title`,
          content: pageTitle // Use page title for Twitter title
        },
        {
          name: `twitter:description`,
          content: metaDescription
        }
      ]
        .concat(
          keywords && keywords.length > 0
            ? {
              name: `keywords`,
              content: keywords.join(`, `)
            }
            : []
        )
        .concat(meta || [])}
    />
  );
  // return (
  //   <StaticQuery
  //     query={detailsQuery}
  //     render={(data) => {
  //       const metaDescription =
  //         description || data.site.siteMetadata.description;
  //       return (
  //         <Helmet
  //           htmlAttributes={{
  //             lang
  //           }}
  //           title={data.site.siteMetadata.author}
  //           titleTemplate={`%s • ${data.site.siteMetadata.title}`}
  //           meta={[
  //             {
  //               name: `description`,
  //               content: metaDescription
  //             },
  //             {
  //               property: `og:title`,
  //               content: title
  //             },
  //             {
  //               property: `og:description`,
  //               content: metaDescription
  //             },
  //             {
  //               property: `og:type`,
  //               content: `website`
  //             },
  //             {
  //               name: `twitter:card`,
  //               content: `summary`
  //             },
  //             {
  //               name: `twitter:creator`,
  //               content: data.site.siteMetadata.author
  //             },
  //             {
  //               name: `twitter:title`,
  //               content: title
  //             },
  //             {
  //               name: `twitter:description`,
  //               content: metaDescription
  //             }
  //           ]
  //             .concat(
  //               keywords.length > 0
  //                 ? {
  //                     name: `keywords`,
  //                     content: keywords.join(`, `)
  //                   }
  //                 : []
  //             )
  //             .concat(meta)}
  //         />
  //       );
  //     }}
  //   />
  // );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: []
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string
};

export default SEO;

// const detailsQuery = graphql`
//   query DefaultSEOQuery {
//     site {
//       siteMetadata {
//         title
//         description
//         author
//       }
//     }
//   }
// `;
